// This file is automatically generated by AutoIndexPlugin. Do not edit manually.
import './ajax-form';
import './ajax-invalid-feedback';
import './attributes';
import './fingerprint';
import './handler/application';
import './handler/contact';
import './handler/registered-data';
import './handler/vote';
import './handler/winner';
import './idempotency';
import './recaptcha';
import './types';
import './validation';
